import { ZtIcon } from '../zt-icon/zt-icon.model';

export enum ZtButtonType {
    PRIMARY = 'zt-btn-primary',
    SECONDARY = 'zt-btn-secondary',
    TERTIARY = 'zt-btn-tertiary',
}

export interface ZtButtonConfig {
    id?: string;
    icon?: ZtIcon;
    label?: string;
    name?: string;
}
